import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'//import firebase from '../firebase'
//import firestore from '@firebase/firestore'
import Store from '../store/Store'
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import MergeHelpers from '../helpers/MergeHelpers'
import Vue from 'vue'
import StringHelpers from '../helpers/StringHelpers'
import TablesStore from '../store/CollectionsStore'
// import { innerMode } from 'codemirror'
import Utilities from '../helpers/Utilities'
import Actions from './Actions'
import AlertHelpers from '../helpers/AlertHelpers'
import Firestore from '../data/Firestore'
import TeamHelpers from '../helpers/TeamHelpers'


export default class {

    constructor(path) {
        if(path.indexOf('/') > -1)
            this.path = path
        else
            this.collection = path
    }

    load() {
        return new Promise(async (resolve, reject) => {
            
            if(!this.teams) {
                const teams = await TeamHelpers.fetchActiveTeams()
                this.teams = teams.map(team => team._id)
            }
            
            const promises = []
            this.teams.forEach(team => { 
                let ref = Firestore.getFirestore().collection(`teams/${team}/collections/${this.collection}/data`)
                this.conditions.forEach(condition =>{
                    ref = ref.where(condition.field, condition.operator, condition.value)
                })
                ref = ref.limit(this.limit)
                const prom = Firestore.fetchCollection(ref)
                promises.push(prom)
            })
            Promise.all(promises).then(results => {
                let mergedItems = []
                results.forEach(arr => {
                    mergedItems = [...mergedItems, ...arr].map(item => {
                        return {...item, _collection: this}
                    })
                })
                
                const sortField = this.sortField
                if(sortField)
                    mergedItems = mergedItems.sort((a,b) => OrderHelpers.sortByField(a, b, sortField))
                console.log('there are items: ' + mergedItems.length)
                this.data = mergedItems
                this.status = 'loaded'
                resolve(this.data)
            })                    
        })

    }

    get path() {
        return this._path
    }

    set path(value) {
        this._path = value
    }

    get teams() {
        return this._teams
    }
    set teams(value) {
        this._teams = value
    }
    get collection() {
        return this._collection
    }
    set collection(value) {
        this._collection = value
    }
    get conditions() {
        return this._conditions || []
    }
    set conditions(value) {
        this._conditions = value
    }
    get limit() {
        return this._limit || 100
    }
    set limit(value) {
        this._limit = value
    }
    get sortField() {
        return this._sortField || 100
    }
    set sortField(value) {
        this._sortField = value
    }

    get data() {
        return this._data
    }

    set data(value) {
        this._data = value
    }



} // end class


// WEBPACK FOOTER //
// ./src/data/Collection.js